import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Buttons } from 'lidya-common-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import TermsAndConditions from './terms.conditions';

import './terms.conditions.base.less';

const getTitleAndContent = ({
  t, privacy, conditions, cookies, job, nbcb,
}) => {
  switch (true) {
    case privacy:
      return {
        title: t('web.privacy.conditions.title'),
        content: <TermsAndConditions textKey="web.privacy.conditions.text" />,
      };
    case conditions:
      return {
        title: t('web.careers.openings.form.terms.conditions.title'),
        content: <TermsAndConditions textKey="web.terms.conditions.text" />,
      };
    case cookies:
      return {
        title: `${t('web.popup.cookies')} ${t(
          'web.privacy.conditions.secondary',
        )}`,
        content: <TermsAndConditions textKey="web.cookies.policy.text" />,
      };

    case job:
      return {
        title: t('web.careers.openings.form.terms.conditions.title'),
        content: (
          <TermsAndConditions textKey="web.careers.openings.form.terms.conditions" />
        ),
      };
    case nbcb:
      return {
        title: t('web.nbcb.terms.conditions.title'),
        content: <TermsAndConditions textKey="web.privacy.nbcb" />,
      };

    default:
      return {
        title: t('web.careers.openings.form.terms.conditions.title'),
        content: <TermsAndConditions textKey="web.terms.conditions.text" />,
      };
  }
};

function TermsAndPrivacy({
  privacy, conditions, cookies, job, nbcb,
}) {
  const { t } = useTranslation();
  const { title, content } = useMemo(
    () => getTitleAndContent({
      t,
      privacy,
      conditions,
      cookies,
      job,
      nbcb,
    }),
    [conditions, cookies, job, nbcb, privacy, t],
  );

  return (
    <div className="o-termsConditions">
      <div className="m-globalContentContainer m-globalContentContainer__termsConditions">
        <div className="m-termsConditions__offerContainer">
          <div className="m-termsConditions__backLink">
            <Buttons.IconTextButton
              className="a-termsConditions__backBtn"
              type={Buttons.BUTTON_TYPES.ICON_TEXT_PRIMARY}
              icon="arrow-left"
              onClick={() => window.history.back()}
            >
              {t('web.terms.conditions.back')}
            </Buttons.IconTextButton>
          </div>
          <div className="m-termsConditions__card">
            <div className="m-termsConditions__titleContainer">
              <h1 className="a-termsConditions__title -page-title">{title}</h1>
            </div>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}

TermsAndPrivacy.propTypes = {
  conditions: PropTypes.bool,
  cookies: PropTypes.bool,
  job: PropTypes.bool,
  nbcb: PropTypes.bool,
  privacy: PropTypes.bool,
};

TermsAndPrivacy.defaultProps = {
  conditions: false,
  cookies: false,
  job: false,
  nbcb: false,
  privacy: false,
};

export default TermsAndPrivacy;
